import { apiUrl } from '@/api/axios';
import { handleResponseError } from '@/core/utils/handleResponseError';

/**
 * Минимальный структурный контракт generic-слайса (`createGenericSlice`),
 * который нужен этой утилите. Намеренно уже, чем RTK `Slice`, чтобы подходили
 * и реальные слайсы, и структурные моки в тестах. Методный синтаксис даёт
 * бивариантную проверку параметров — поэтому типизированные `PayloadAction`-
 * креаторы тоже присваиваются.
 */
interface FetchDataSlice {
    actions: {
        fetchDataStart(): unknown;
        setDataLoaded(data: unknown): unknown;
        fetchDataError(payload: { errorMessage: string; isNetworkError?: boolean }): unknown;
    };
}

export const fetchData = (slice: FetchDataSlice, url: string) => (id?: number | null) => async (dispatch) => {
    dispatch(slice.actions.fetchDataStart());

    try {
        const requestUrl = id ? `${url}${id}` : url;
        const response = await apiUrl.get(requestUrl);

        const data = response.data.data;
        // console.log('Data fetched successfully:', data);

        dispatch(slice.actions.setDataLoaded(data));
    } catch (error) {
        console.error('Error during data fetch:', error);
        handleResponseError(error, (errorMessage, isNetworkError) => {
            dispatch(slice.actions.fetchDataError({ errorMessage, isNetworkError }));
        });
    }
};